import { all, takeEvery, put } from 'redux-saga/effects';
import actions from './actions';
import RestApi from '../../helpers/api';

const api = new RestApi('companies/unsigned-metric');

export function* loadCompanyRequest(data) {
  try {
    const { payload } = data;

    const response = yield api.load(payload);

    if (response.status === 'success') {
      const { data } = response;

      yield put(
        actions.loadCompanySuccess({
          data,
        }),
      );
    } else if (response.status === 'error') {
      const { error } = response.data;

      yield put(actions.loadError(error));
    }
  } catch (error) {
    console.warn(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD_COMPANY_REQUEST, loadCompanyRequest)]);
}
